export const subjectAdapter = (subject) => {
  return {
    id: subject.id,
    createdAt: subject.created_at,
    title: subject.title,
    description: subject.description,
    shared_source: subject.shared_source,
  };
};

export const subjectDetailAdapter = (subject) => {
  const simpleQuery =
    subject.simple_query && JSON.parse(subject.simple_query || '[]');

  return {
    step: 0,
    isDefault: false,
    id: subject.id,
    description: subject.description,
    title: subject.title,
    parsedQuery: subject.parsed_query,
    type: subject.simple_query ? 'simple' : 'advance',
    contain: subject.simple_query ? simpleQuery?.contain : [],
    mustContain: subject.simple_query ? simpleQuery?.must_contain : [],
    mustNotContain: subject.simple_query ? simpleQuery?.must_not_contain : [],
  };
};
